import { Card, CardContent, CardHeader } from "@/components/ui/card";

import { Skeleton } from "@/components/ui/skeleton";

export function ChartSkeleton() {
  return (
    <Card className="p-8">
      <CardHeader className="p-8">
        <div className="flex items-center gap-2 p-8">
          <Skeleton className="h-5 w-5" />
          <Skeleton className="h-6 w-24" />
        </div>
        <Skeleton className="h-4 w-48" />
      </CardHeader>
      <CardContent>
        <Skeleton className="h-[200px] w-full" />
      </CardContent>
    </Card>
  );
}

export function RadarChartSkeleton() {
  return (
    <Card className="lg:col-span-2 min-w-72">
      <CardHeader className="p-8">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-4 w-40" />
      </CardHeader>
      <CardContent className="flex justify-center items-center">
        <Skeleton className="h-72 w-72 rounded-full" />
      </CardContent>
    </Card>
  );
}

export function MetricCardSkeleton() {
  return (
    <Card className="p-8 min-w-44">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-20" />
        </div>
        <Skeleton className="h-4 w-4" />
      </CardHeader>
      <CardContent>
        <Skeleton className="h-8  mb-2" />
        <Skeleton className="h-3 mb-1" />
        <Skeleton className="h-3 " />
      </CardContent>
    </Card>
  );
}

export function OverallChartSkeleton() {
  return (
    <Card>
      <CardHeader className="p-8">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-4 w-64" />
      </CardHeader>
      <CardContent className="p-8">
        <Skeleton className="h-[400px] w-full" />
      </CardContent>
    </Card>
  );
}
